import {create} from "zustand";

import {Shift} from "../types";

type ShiftsStoreState = {
  activeShift: Shift | null;
  shifts: Shift[];
  draggedShift: Shift | null;
};

type ShiftsStoreActions = {
  setActiveShift: (shift: Shift | null) => void;
  setShifts: (shifts: Shift[]) => void;
  setDraggedShift: (shift: Shift) => void;
  clearDraggedShift: () => void;
  clear: () => void;
};

export const useShiftsStore = create<ShiftsStoreState & ShiftsStoreActions>((set) => ({
  activeShift: null,
  shifts: [],
  draggedShift: null,

  setActiveShift: (shift: Shift | null) => set({activeShift: shift}),
  setShifts: (shifts: Shift[]) => set((state) => ({shifts: [...state.shifts, ...shifts]})),
  setDraggedShift: (shift: Shift) => set({draggedShift: shift}),
  clearDraggedShift: () => set({draggedShift: null}),
  clear: () => set({activeShift: null, shifts: [], draggedShift: null}),
}));

export function useStoredShifts() {
  return useShiftsStore((state) => state.shifts);
}

export function useStoredActiveShift() {
  return useShiftsStore((state) => state.activeShift);
}

export function useSetActiveShift() {
  return useShiftsStore((state) => state.setActiveShift);
}

export function useSetShifts() {
  return useShiftsStore((state) => state.setShifts);
}

export function useStoredUnscheduledShifts() {
  const shifts = useStoredShifts();

  return shifts.filter((shift) => shift.status === "unscheduled" && shift.user?.id);
}

export function useStoredClearShifts() {
  return useShiftsStore((state) => state.clear);
}
